module.exports = __webpack_public_path__ + "media/images/result_sets/circles/6n7n9r3n-51079a4bd60289ae8767ebc8b217bead.svg";